// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"adbc61ec","3":"adbc61ec","404":"3f2f3da2","677":"adbc61ec"}[chunkId] + ".chunk.css";
};